import React, { useContext, useEffect, useState } from 'react';
import { NavHeightContext } from '../App';
import '../helper/animation.css';
import HomeButtons from '../helper/HomeButtons';
import {
  githubIcon,
  linkedinIcon,
  youtubeIcon,
  myEmailId,
  myPhoto,
  myLocation,
  myName,
  myLinkedInURL,
  myGitHubURL,
  myYoutubeURL,
  homeTextColor,
} from '../helper/constants';
import {
  FaLocationArrow,
  FaEnvelope,
  FaCopy,
  FaCheckCircle,
} from 'react-icons/fa';

const Home = () => {
  const [screenWidth, setScreenWidth] = useState(0);
  const [screenHeight, setScreenHeight] = useState(0);

  const navHeight = useContext(NavHeightContext);
  const [successMessage, setSuccessMessage] = useState({
    visible: false,
    text: '',
  });

  // const [animationPaused, setAnimationPaused] = useState(false);

  // const handleMouseOver = () => {
  //   setAnimationPaused(true);
  // };

  // const handleMouseOut = () => {
  //   setAnimationPaused(false);
  // };

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
      setScreenHeight(window.innerHeight);
    };

    // Set initial screen dimensions
    setScreenWidth(window.innerWidth);
    setScreenHeight(window.innerHeight);

    // Event listener for window resize
    window.addEventListener('resize', handleResize);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const sectionDynamic = {
    width: `${screenWidth}px`,
    height: `${screenHeight}px`,
    paddingTop: `${navHeight}px`, // Use the navHeight value for marginTop
  };

  const homeContentDynamic = {
    // paddingTop: `${navHeight}px`, // Use the navHeight value for marginTop
  };

  const handleCopyToClipboard = () => {
    navigator.clipboard
      .writeText(myEmailId)
      .then(() => {
        setSuccessMessage({
          visible: true,
          text: 'Copied to clipboard!',
        });
        setTimeout(() => {
          setSuccessMessage({
            visible: false,
            text: '',
          });
        }, 3000);
      })
      .catch((error) => {
        console.error('Failed to copy URL to clipboard:', error);
      });
  };

  const contentSection = (
    <ul style={styles.bullets}>
      <li style={styles.bulletItem}>
        Master's Graduate | Seeking Full-Time Opportunities{' '}
      </li>
      <li style={styles.bulletItem}>Software Developer</li>
      <li style={styles.bulletItem}>
        MS in Information Systems @ Northeastern University, Boston
      </li>
      <li style={styles.bulletItem}>
        Ex iOS Engineer Intern @ Diall | Ex Software Developer @ Infosys
      </li>
      {/* <li style={styles.bulletItem}>
        Professional work experience of over 5 years in Java, coupled with a
        3-month stint in React Native.
      </li>
      <li style={styles.bulletItem}>
        Reimagined as a professional statement: I am committed to embracing a
        T-shaped specialization, leveraging a broad range of skills while
        maintaining expertise in specific areas.
      </li> */}
    </ul>
  );

  const bottomRightSection = (
    <div>
      <div style={styles.iconSection}>
        <a href={myLinkedInURL} target='_blank' rel='noopener noreferrer'>
          <img src={linkedinIcon} alt='Linkedin' style={styles.iconImage} />
        </a>
        &nbsp;
        <a href={myGitHubURL} target='_blank' rel='noopener noreferrer'>
          <img src={githubIcon} alt='GitHub' style={styles.iconImage} />
        </a>
        &nbsp;
        <a href={myYoutubeURL} target='_blank' rel='noopener noreferrer'>
          <img src={youtubeIcon} alt='Youtube' style={styles.iconImage} />
        </a>
        &nbsp;
        {/* <a href={myInstagramURL} target='_blank' rel='noopener noreferrer'>
          <img src={instagramIcon} alt='Instagram' style={styles.iconImage} />
        </a> */}
      </div>
      <br />
      <a href={`mailto:${myEmailId}`}>
        <FaEnvelope color={homeTextColor} />
      </a>{' '}
      &nbsp;
      {myEmailId}
      &nbsp;
      <a>
        <FaCopy color={homeTextColor} onClick={handleCopyToClipboard} />
      </a>
      <br />
      <FaLocationArrow color={homeTextColor} />
      &nbsp; {myLocation}
    </div>
  );

  return (
    <section
      id='home'
      style={{
        ...styles.sectionStyles,
        ...sectionDynamic,
      }}
    >
      {screenWidth <= 768 ? (
        <div>
          <div
            style={{
              ...styles.leftSideMobile,
              ...homeContentDynamic,
              color: homeTextColor,
            }}
          >
            <h1>{myName}</h1>
            <h3>Welcome to my portfolio!</h3>
            <div>{contentSection}</div>

            <div style={{ ...styles.bottom, flexDirection: 'column' }}>
              <div style={styles.bottomLeft}>
                <HomeButtons />
              </div>
              <div style={{ ...styles.bottomRight, marginTop: '5px' }}>
                {bottomRightSection}
              </div>
            </div>
          </div>

          <div style={styles.rightSideMobile}>
            <div style={styles.imageContainer}>
              <img
                src={myPhoto}
                alt='My Picture4'
                style={{ ...styles.myImage }}
              />
            </div>
          </div>

          {successMessage.visible && (
            <div style={styles.successMessage}>
              <div style={styles.successIcon}>
                <FaCheckCircle style={styles.successIconCircle} />
              </div>
              <div style={styles.successText}>{successMessage.text}</div>
            </div>
          )}
        </div>
      ) : (
        <div
          style={{
            ...styles.homeContent,
            ...homeContentDynamic,
          }}
        >
          <div style={{ ...styles.leftSide, color: homeTextColor }}>
            <div style={styles.leftSideInside}>
              <h1>Vignesh Gunasekaran</h1>
              <h3>Welcome to my portfolio!</h3>
              <div>{contentSection}</div>

              <div style={styles.bottom}>
                <div style={styles.bottomLeft}>
                  <HomeButtons />
                </div>
                <div style={styles.bottomRight}>{bottomRightSection}</div>
              </div>
            </div>
          </div>

          <div style={styles.rightSide}>
            <div style={styles.imageContainer}>
              <img src={myPhoto} alt='My Picture2' style={styles.myImage} />
            </div>
          </div>
        </div>
      )}

      {/* </div> */}

      {/* <div
        className='home-bottom-content'
        style={styles.marquee}
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
      >
        <div className={`rolling-text ${animationPaused ? 'paused' : ''}`}>
          <span className='rolling-text-item'>No Assumptions</span>
          <span className='rolling-text-item'>Get the work done</span>
          <span className='rolling-text-item'>Time is precious</span>
          <span className='rolling-text-item'>
            Health &amp; Family comes first than work
          </span>
          <span className='rolling-text-item'>Speak out</span>
          <span className='rolling-text-item'>Leo = Work Ethics</span>
          <span className='rolling-text-item'>Enjoy your life</span>
        </div>
      </div> */}

      {successMessage.visible && (
        <div style={styles.successMessage}>
          <div style={styles.successIcon}>
            <FaCheckCircle style={styles.successIconCircle} />
          </div>
          <div style={styles.successText}>{successMessage.text}</div>
        </div>
      )}
    </section>
  );
};

const styles = {
  sectionStyles: {
    background: 'linear-gradient(45deg, #C13584, #8134AF, #405DE6, #5851DB)',
    marginTop: '-20px',
  },
  homeContent: {
    marginTop: '20px',
    margin: '20px',
    padding: '15px',
    display: 'flex',
    height: '90%',
    // border: '2px solid red',
  },
  // leftSide: {
  //   // border: '2px solid black',
  //   padding: '10px',
  //   width: '70%',
  //   // height: '100%',
  //   // textAlign: 'center',
  //   borderRadius: '10px',
  //   boxShadow: '0 0 5px rgba(0, 0, 0, 0.3)',
  //   // flex: 1,
  //   // display: 'flex',
  //   // alignItems: 'center',
  //   overflow: 'hidden',
  //   textOverflow: 'ellipsis',
  //   // whiteSpace: 'nowrap',
  //   wordBreak: 'break-word',
  // },
  leftSideMobile: {
    padding: '10px',
    width: '90%',
    borderRadius: '10px',
    boxShadow: '0 0 5px rgba(0, 0, 0, 0.3)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
    margin: '10px',
  },
  leftSide: {
    padding: '10px',
    width: '70%',
    borderRadius: '10px',
    boxShadow: '0 0 5px rgba(0, 0, 0, 0.3)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
    alignSelf: 'center',
    // backgroundColor: '#FFFFFF',
    // opacity: '30%',
    // backgroundColor: 'linear-gradient(45deg, #818181, #000000)',
    // opacity: '0.3',

    // backdropFilter: 'blur(100px)',
    // border: '2px solid black',
    // color: 'white',
  },
  // leftSideInside: {
  //   zIndex: 2,
  //   backgroundColor: 'transparent',
  //   opacity: 1,
  // },
  rightSide: {
    width: '30%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  rightSideMobile: {
    width: '30%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '5px',
    // flexDirection: 'column',
    // border: '1px solid red',
    // alignSelf: 'center',
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  myImage: {
    // width: 240 / 2,
    // height: 440 / 2,
    // height: '100%',
    // width: 'auto',
    width: '60%',
    // height: 'auto', // This will maintain the image's aspect ratio
    // height: '10%',
    imageRendering: 'crisp-edges', // Ensures the image retains its sharpness
    objectFit: 'contain', // Adjust the object-fit property as needed
    borderRadius: '10px',
  },
  bottom: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '20px',
  },
  bottomLeft: {
    flex: 1,
    textAlign: 'left',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
  },
  bottomRight: {
    flex: 1,
    textAlign: 'right',
    justifyContent: 'center',
    alignItems: 'center',
  },
  iconSection: {
    // display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconImage: {
    width: 30,
    height: 30,
  },
  marquee: {
    color: homeTextColor,
  },
  successMessage: {
    position: 'fixed',
    bottom: '80px',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#000',
    color: '#fff',
    borderRadius: '5px',
    padding: '10px 20px',
    zIndex: 9999,
  },
  successIcon: {
    marginRight: '10px',
  },
  successIconCircle: {
    color: 'green',
    fontSize: '18px',
  },
  successText: {
    fontSize: '14px',
  },
  bullets: {
    // listStyleType: 'none',
    // padding: 0,
  },
  bulletItem: {
    marginBottom: '10px', // Adjust the spacing between each list item
  },
};

export default Home;
